import { Box, BoxProps, Breadcrumb, HStack } from '@chakra-ui/react'
import {
  AppPanelToggleButton,
  AppPanelToggleButtonProps,
} from '@src/components/sco/AppLayout/Panel/AppPanelToggleButton.tsx'
import { NextLink } from '@src/components/sco/utilities/NextLink'
import { BreadcrumbItem, useActiveContentContext } from '@src/contexts/ActiveContentContext'
import React, { Fragment } from 'react'

export type AppLayoutToolbarProps = {
  boxProps?: BoxProps
  breadcrumbs?: BreadcrumbItem[]
  children?: React.ReactNode
  leftElements?: React.ReactNode
  rightElements?: React.ReactNode
  hideRightToggleButton?: boolean
  hideLeftToggleButton?: boolean
  hideBreadcrumbs?: boolean
  toggleButtonProps?: Partial<AppPanelToggleButtonProps>
}

export const AppLayoutToolbar: React.FC<AppLayoutToolbarProps> = props => {
  const activeContent = useActiveContentContext()

  return (
    <HStack
      align={'center'}
      backdropFilter={'blur(10px)'}
      bgColor={'colorPalette.container/90'}
      borderBottom={'1px solid {colors.colorPalette.border/25}'}
      borderTopRadius={'md'}
      gap={3}
      justify={'stretch'}
      minHeight={'3.5rem'}
      padding={3}
      position={'sticky'}
      top={0}
      width={'full'}
      zIndex={'docked'}
      {...props.boxProps}
    >
      {props.children ? (
        props.children
      ) : (
        <>
          {!props.hideLeftToggleButton && (
            <AppPanelToggleButton panelId={'*-nav'} panelPosition={'left'} {...props.toggleButtonProps} />
          )}
          {/** Breadcrumbs */}
          {!props.hideBreadcrumbs && (
            <Box flexGrow={props.leftElements ? 0 : 1}>
              <Breadcrumb.Root fontSize={'sm'}>
                <Breadcrumb.List gap={1}>
                  {(props.breadcrumbs || activeContent.breadcrumbs || []).map(
                    (breadcrumb, index, breadcrumbs) => (
                      <Fragment key={`${breadcrumb.href}-${index}`}>
                        <Breadcrumb.Item>
                          <Breadcrumb.Link
                            asChild
                            _hover={{ color: 'colorPalette.fg', textDecoration: 'none' }}
                            fontWeight={'semibold'}
                            lineClamp={1}
                            color={
                              index === breadcrumbs.length - 1 ? 'colorPalette.fg/80' : 'colorPalette.fg/60'
                            }
                          >
                            <NextLink href={breadcrumb.href}>{breadcrumb.title || '...'}</NextLink>
                          </Breadcrumb.Link>
                        </Breadcrumb.Item>
                        {index < breadcrumbs.length - 1 ? <Breadcrumb.Separator /> : null}
                      </Fragment>
                    )
                  )}
                </Breadcrumb.List>
              </Breadcrumb.Root>
            </Box>
          )}
          {props.leftElements}

          {props.rightElements}

          {/** Right Menu Icon */}
          {!props.hideRightToggleButton && activeContent.item?.id && (
            <HStack>
              <AppPanelToggleButton
                panelId={'*-aside'}
                panelPosition={'right'}
                {...props.toggleButtonProps}
              />
            </HStack>
          )}
        </>
      )}
    </HStack>
  )
}
